import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ENTERPRISE_DEMO_IEAM_2 = {
  title: "Software deployment wizard\n for specific use cases",
  subtitle: "Enterprise demo",
  text: "The user can choose to deploy the software for \n their specific use case by following the \n deployment wizard.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_113"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_111"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_01.png",
  rightSideImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_02.png",
};
